// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Bh-z","subtitle":"Ch-z","contentWrap":"Dh-z","imgWrap":"Eh-z","heading":"Fh-z","copy":"Gh-z"};